
if ($('#sucursales-semaforo').length > 0) {
    setInterval(refrescarSemaforos, 5000);
}

function refrescarSemaforos() {
    //console.log('Sucursales semaforo');
    $.ajax({
        url: '/kiosko/status',
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            data.forEach(function (sucursal) {
                let fila = $('tr[data-id="' + sucursal.id + '"]');
                let circulo = fila.find('.estado-circle');

                circulo
                    .removeClass('bg-success bg-warning bg-danger')
                    .addClass('bg-' + sucursal.color)
                    .attr('title', 'Inicio: ' + sucursal.inicio + ' | Fin: ' + sucursal.fin)
                    .tooltip('dispose')
                    .tooltip();
            });
        },
        error: function (xhr, status, error) {
            console.error('Error al refrescar semáforos:', error);
        }
    });

}


